import React from "react";
import { buttonText, getTitleParaFun } from "../constants/ConstantsVariable";
import { showSwalPopup } from "../../notes/actions/ShowSwalPopup";
import HeaderCompNew from "./shares/newHeaderComp";
import CheckListCompNew from "./shares/newCheckList";
import CommonButtonNew from "./shares/newCommonButton";

const ScreenThreeComp = ({
   isStepthree,
   onClick = () => {},
   updateStripeStatus = () => {},
   handleContactFun = () => {},
   setIsNeedMoreTime,
   isStepFour,
   navigateFun,
}) => {
   const handleClick = () => {
      if (isStepthree) {
         setIsNeedMoreTime(true);
      }
      onClick();
   };
   const handlePopupClick = () => {
      if (isStepthree === 3) {
         showSwalPopup(
            "Extend trial by 2 days",
            "Extend trial for two more days on us!",
            "Confirm",
            "Confirm",
            "Cancel",
            () => {
               updateStripeStatus();
            },
            () => {
               navigateFun();
            },
            false,
            false,
            false,
            false,
            true
         );
      }
   };
   return (
      <>
         <HeaderCompNew text={getTitleParaFun(3)} />
         <div className="pg-middle-container-new-ui">
            <CheckListCompNew />
         </div>
         <div className="pg-button-container-new-ui pg-button-margin-container-new-ui ">
            <CommonButtonNew
               id="signUp-button-v2"
               btnText={isStepthree === 3 ? buttonText(3) : buttonText(4)}
               onClick={isStepthree === 3 ? handlePopupClick : handleContactFun}
               loading={false}
               isbuttonWidth={true}
               buttonWidth={(isStepthree === 3 && "272px") || "412px"}
            />
            <CommonButtonNew
               id="signUp-button-v2"
               btnText={isStepFour === 4 ? buttonText(6) : buttonText()}
               onClick={handleClick}
               loading={false}
               isWhiteBtn={true}
               isbuttonWidth={true}
               buttonWidth={(isStepthree === 3 && "272px") || "412px"}
            />
         </div>
      </>
   );
};

export default ScreenThreeComp;
